import React, { createContext, ReactNode, useContext } from "react";

import { IHOMPropertyService } from "../types/services/hom-property-service";

const HOMPropertyServiceContext = createContext<IHOMPropertyService>(
  undefined as any,
);

interface HOMPropertyServiceProviderProps {
  children: ReactNode;
  service: IHOMPropertyService;
}

function HOMPropertyServiceProvider(
  props: HOMPropertyServiceProviderProps,
) {
  const { children, service } = props;

  return (
    <HOMPropertyServiceContext.Provider value={service}>
      {children}
    </HOMPropertyServiceContext.Provider>
  );
}

function useHOMPropertyService() {
  return useContext(HOMPropertyServiceContext);
}

export { HOMPropertyServiceProvider, useHOMPropertyService };
